
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, LoaderIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import { toast } from "sonner";
import { Label } from "../ui/label";
import { apiClient } from "@/services/api";

const SignUpForm = () => {

    const navigate = useNavigate();

    const [name, setName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleSignUp = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!name || !email || !password) {
            toast.error("Nome, email e senha são obrigatórios!");
            return;
        }

        if (password.length < 8) {
            toast.error("A senha deve ter pelo menos 8 caracteres.");
            return;
        }

        setIsLoading(true);

        try {
            await apiClient.post('/auth/register', {
                name,
                email,
                password,
            });

            toast.success("Conta criada com sucesso! Faça login.");
            navigate("/auth/sign-in");
        } catch (error: any) {
            const message = error?.response?.data?.message || error?.message;
            toast.error(message || "Erro ao criar conta. Tente novamente.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
            <h2 className="text-2xl font-semibold">
                Criar conta
            </h2>

            <form onSubmit={handleSignUp} className="w-full">
                <div className="space-y-2 w-full">
                    <Label htmlFor="name">
                        Nome Completo
                    </Label>
                    <Input
                        id="name"
                        type="text"
                        value={name}
                        disabled={isLoading}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Digite seu nome completo"
                        className="w-full focus-visible:border-foreground"
                    />
                </div>
                <div className="mt-4 space-y-2 w-full">
                    <Label htmlFor="email">
                        Email
                    </Label>
                    <Input
                        id="email"
                        type="email"
                        value={email}
                        disabled={isLoading}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Digite seu email"
                        className="w-full focus-visible:border-foreground"
                    />
                </div>
                <div className="mt-4 space-y-2">
                    <Label htmlFor="password">
                        Senha
                    </Label>
                    <div className="relative w-full">
                        <Input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            disabled={isLoading}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Digite sua senha"
                            className="w-full focus-visible:border-foreground"
                        />
                        <Button
                            type="button"
                            size="icon"
                            variant="ghost"
                            className="absolute top-1 right-1"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ?
                                <EyeOff className="w-4 h-4" /> :
                                <Eye className="w-4 h-4" />
                            }
                        </Button>
                    </div>
                    <p className="text-xs text-muted-foreground">
                        A senha deve ter pelo menos 8 caracteres
                    </p>
                </div>
                <div className="mt-4 w-full">
                    <Button
                        type="submit"
                        disabled={isLoading}
                        className="w-full"
                    >
                        {isLoading ? (
                            <LoaderIcon className="w-5 h-5 animate-spin" />
                        ) : "Criar Conta"}
                    </Button>
                </div>
            </form>

            <div className="mt-6 text-center text-sm text-muted-foreground">
                <p>Já tem uma conta?</p>
                <Button variant="link" className="p-0 h-auto font-normal">
                    <a href="/auth/sign-in">Fazer login</a>
                </Button>
            </div>
        </div>
    )
};

export default SignUpForm
